import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import { setLogoutUser } from "../reducers/users/userSlices";
import { setLogoutUserSession } from "../reducers/sessions/sessionauthcodeSlices";
import { setLogoutAuthCode } from "../reducers/authorization/authorizationcodeSlices";
import { cleanCodeAuth } from "../reducers/authorization/codeauthorizationSlices";
import { cleanUpdateAuth } from "../reducers/authorization/updateautorizacionSlices";
import { CleanReprintReportData } from "../reducers/reports/reprintreport";
import { setEmptyServices } from "../reducers/services/servicesSlices";

const TimeOutSession = () => {

  const { plastico, mensage } = useSelector((state) => state.authcode);
  const { codauth, message } = useSelector((state) => state.codeauth);
  const { autorizacion, coddia, telefono, diagno, mesage } = useSelector((state) => state.updateauth);
  const { reprintdata } = useSelector((state) => state.reprint);
  //const { addservices } = useSelector((state) => state.addservices);
  const { services } = useSelector((state) => state.services);
  const { usersession } = useSelector((state) => state.sessionuser);
  const { usuario, clave, codPss, descripcion, token } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  /* -------------------------------  Verifica la inactividad y cierra sesion  -------------------------------------  */

  const checkForInactivity = () => {
    const expireTime = localStorage.getItem("expiretime");

    // verifica si la variable es menor al tiempo actual
    if (expireTime < Date.now()) {
      let timerInterval;
      Swal.fire({
        title: "OK",
        html: "La sesion se cierra en <b></b> milliseconds.",
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
          const b = Swal.getHtmlContainer().querySelector("b");
          timerInterval = setInterval(() => {
            b.textContent = `${Swal.getTimerLeft()}`;
          }, 100);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          dispatch(
            setLogoutAuthCode({
              plastico: plastico,
              mensage: mensage,
            })
          );
  
          dispatch(
            cleanCodeAuth({
              codauth: codauth,
              message: message,
            })
          );
  
          dispatch(
            cleanUpdateAuth({
              autorizacion: autorizacion,
              coddia: coddia,
              telefono: telefono,
              diagno: diagno,
              mesage: mesage,
            })
          );
  
          dispatch(
            CleanReprintReportData({
              reprintdata: reprintdata,
            })
          );
  
          dispatch(setEmptyServices(services));
  
          dispatch(
            setLogoutUserSession({
              usersession: usersession,
            })
          );
  
          dispatch(
            setLogoutUser({
              usuario: usuario,
              clave: clave,
              codPss: codPss,
              descripcion: descripcion,
              token: token,
            })
          );

          // Cerrar sesión, eliminar el token de sesión
          localStorage.removeItem("sessionToken");
          localStorage.setItem('sessionActive', 'false');

          setTimeout(() => {
            navigate("/");
            window.location.reload();
          }, 1500);
        }
      });
    }
  };

  /* -------------------------------  Actualiza el tiempo de inactividad -------------------------------------  */

  const updateExpireTime = () => {
    const expireTime = Date.now() + 10 * 60 * 1000;
    //const expireTime = Date.now() + 20000;

    // para modificar el el tiempo de cierre de session
    localStorage.setItem("expiretime", expireTime);
  };

  // para modificar el intervalo de la inactividad
  useEffect(() => {
    // Verifica la inactividad cada 5 segundos
    const interval = setInterval(() => {
      checkForInactivity();
    }, 5000);

    return () => clearInterval(interval);
  });

  useEffect(() => {
    //Actualiza el tiempo
    updateExpireTime();

    // actualizar los event listener
    window.addEventListener("click", updateExpireTime);
    window.addEventListener("keypress", updateExpireTime);
    window.addEventListener("scroll", updateExpireTime);
    window.addEventListener("mousemove", updateExpireTime);

    return () => {
      // elimina los event listener
      window.removeEventListener("click", updateExpireTime);
      window.removeEventListener("keypress", updateExpireTime);
      window.removeEventListener("scroll", updateExpireTime);
      window.removeEventListener("mousemove", updateExpireTime);
    };
  });

  return <div></div>;
};

export default TimeOutSession;
